import { COAT, COAT_PANT, PANT, SHIRT, VEST } from './garments'

//* ---------------- PRICES ---------------- *//
export const PRICE_PROFILES = [
  { id: 1, title: 'USD', symbol: '$', rate: 1 },
  { id: 13, title: 'GBP', symbol: '£', rate: 0.625 },
  { id: 15, title: 'EURO', symbol: '€', rate: 0.7 },
  { id: 16, title: 'RMB', symbol: '¥', rate: 6.39 },
  { id: 17, title: 'AUD', symbol: 'AUD', rate: 1.17 },
  { id: 19, title: 'CAN', symbol: 'CAN$', rate: 1.15 },
] as const

//* ---------------- DISTRIBUTION CENTERS ---------------- *//
export const ID = 'iD'
export const FACTORYID = { id: 5, name: 'iD', location: 'China', abbreviation: ID } as const
export const T2ID = 'T2iD'
export const FACTORYT2ID = { id: 6, name: 'Trisco', location: 'Indonesia', abbreviation: T2ID } as const

export const FACTORIES = [FACTORYID, FACTORYT2ID] as const
export const DISTRIBUTION_CENTERS = [FACTORYT2ID] as const

//* ---------------- TAILORING GRADES ---------------- *//
export const TAILORING_GRADES = [
  { name: 'dress', description: 'Dress', garmentTypes: [COAT_PANT, COAT, VEST, PANT, SHIRT] },
  { name: 'casual', description: 'Casual', garmentTypes: [COAT, VEST, PANT] },
] as const

export const TailoringGradeArray = ['casual', 'dress'] as const

//* ---------------- SHIPPING ---------------- *//
export const validCouriers = ['FedEx', 'UPS', 'SFExpress', 'DHL', 'TNT', 'USPS', 'ChungShingExpress', 'Other'] as const

//* ---------------- SKUS ---------------- *//
export const SKU_CATEGORIES = [
  { code: 'BTN', label: 'Button' },
  { code: 'FAB', label: 'Fabric' },
  { code: 'LBL', label: 'Label' },
  { code: 'PAT', label: 'Patch' },
] as const

export const SKU_SUBCATEGORIES = [
  { code: 'CLO', label: 'Clothing', categories: ['BTN', 'FAB'] },
  { code: 'DLR', label: 'Dealer Label', categories: ['LBL'] },
  { code: 'SHT', label: 'Shirting', categories: ['BTN', 'FAB'] },
  { code: 'TRM', label: 'Trim', categories: ['FAB'] },
  { code: 'EMB', label: 'Embroidery Label', categories: ['LBL'] },
  { code: 'LIN', label: 'Lining', categories: ['FAB'] },
  { code: 'LTR', label: 'Leather Patch', categories: ['PAT'] },
  { code: 'MIL', label: 'Mill Label', categories: ['LBL'] },
  { code: 'OTW', label: 'Outerwear', categories: ['BTN'] },
  { code: 'SZL', label: 'Size Label', categories: ['LBL'] },
  { code: 'TCK', label: 'Tack', categories: ['BTN'] },
  { code: 'RVT', label: 'Rivet', categories: ['BTN'] },
] as const

export const getSKUSubcategories = (categoryCode: 'BTN' | 'FAB' | 'LBL' | 'PAT') => {
  return SKU_SUBCATEGORIES.filter(subcategory => (subcategory.categories as readonly string[]).includes(categoryCode))
}

//* ---------------- STOCK STATUS ---------------- *//
export const NOT_AVAILABLE = 'Not Available'
export const SHIP_FROM_VENDOR = 'Ship from Vendor'
export const TRINITY_OWNED = 'Trinity Owned'
